import { Component, Input, OnInit } from '@angular/core';
import { LMBuilderModel } from "@components/builder/services/lm-builder-model.service";

@Component({
  selector:    'lm-builder-display',
  standalone: false,
  templateUrl: './lm-builder-display.component.html',
  styleUrl: './lm-builder-display.component.scss',
})

export class LMBuilderDisplayComponent implements OnInit {
   @Input() spec!: LMListPSpec;

  displaySearchIDSAttributes = [ { name: 'data-automation-id', value: 'lm-builder-display-search' } ];
  defaultViewIDSAttributes = [ { name: 'data-automation-id', value: 'lm-builder-default-view' } ];
  frozenColumnIDSAttributes = [ { name: 'data-automation-id', value: 'lm-builder-frozen-column' } ];
  allowShowLines = false;
  showLines = 0;
  pageSizes:Array<LMBuilderMetaDataOption> = [];
  implementsHorizontalScrolling = false;

  constructor(
      private lmBuilderModel: LMBuilderModel,
  ) {
  // no-op
  }

  ngOnInit(): void {
    this.initialize();
  }

  private initialize() {
    this.implementsHorizontalScrolling = this.spec.frozenColumn > 0;
    this.allowShowLines = this.lmBuilderModel.allowShowLines();
    this.pageSizes = this.lmBuilderModel.buildPageSizes(this.spec?.showLines !== 'default' ? this.spec?.showLines : undefined);
  }

  updateHorizontalScrolling() {
    if (!this.implementsHorizontalScrolling) {
      this.spec.frozenColumn = 0;
    }
  }
}
